export enum AlarmSeverityLevel {
  MINOR = 'MINOR',
  MAJOR = 'MAJOR',
}
